import React, { useEffect, useState } from 'react';
import { api } from 'react-structure-admin';

const useCostCenter = () => {
  const [enabled, setEnabled] = useState(false);
  const [uniqueCostCenter, setUniqueCostCenter] = useState(null);

  useEffect(() => {
    api.fetch('cost-centers/allow-use').then(({ data }) => {
      setEnabled(data?.result);
    });
  }, []);

  useEffect(() => {
    if (uniqueCostCenter === null) {
      api.fetch('cost-centers/unique').then(({ data }) => {
        setUniqueCostCenter(data?.result);
      });
    }
  }, []);

  return { enabledCostCenter: enabled, uniqueCostCenter };
};

export default useCostCenter;
